interface IParameter {
  uuid: string;
  name: string;
  unit: string;
  created_at?: string;
  updated_at?: string;
}

export { IParameter };